import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'users',
            name: 'user',
            class: 'App\\Models\\User'
        }
    },

    methods: {
        allWithHasAnyPermission(permissions) {
            return this.loadAll({
                scopes: {
                    permission: permissions,
                    with: 'permissions'
                }
            })
        },

        prepareResource(resource) {
            resource.formated_owned_company = resource.owned_company_id ? `${resource.owned_company_id}: ${resource.owned_company_name}` : ''
            resource.formated_speaker_company = resource.speaker_company_id ? `${resource.speaker_company_id}: ${resource.speaker_company_name}` : ''

            resource.custom_component_1 = {
                component: 'go-create-company-button'
            }
        },

        withoutCompany() {
            return axios({
                method: 'get',
                url: route('api.users.without.company')
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
        }
    }
}